// Actions
export const DRAG_START = 'DRAG_START';
export const DRAG_END = 'DRAG_END';
export const FORCE_HOVER_EFFECT = 'FORCE_HOVER_EFFECT';
export const CLEAR_HOVER_EFFECT = 'CLEAR_HOVER_EFFECT';

export const DRAG_PREVIEW_ID = 'previewElement';
export const LINE_EDGE_DRAG_PREVIEW_ID = '_LINE_PREVIEW';
